import type { VehicleOrder2Schemas } from './index'

export function getVehicleOrderDiscountSuggestions({
  vehicleOrder,
  twelveMonthRollingOrderedUnitCount,
  vehicleTypesFromSignedVehicleOrders,
  discountConfigurations
}: {
  vehicleOrder: {
    vehicleType: VehicleOrder2Schemas.VehicleOrderVehicleType
    programType: VehicleOrder2Schemas.VehicleOrderProgramType
    seasonType: VehicleOrder2Schemas.VehicleOrderSeasonType
  }
  twelveMonthRollingOrderedUnitCount: number
  vehicleTypesFromSignedVehicleOrders: VehicleOrder2Schemas.VehicleOrderVehicleType[]
  discountConfigurations: VehicleOrder2Schemas.vehicleOrderDiscountConfiguration[]
}) {
  const hasMultiLine = vehicleTypesFromSignedVehicleOrders.some((v) => v !== vehicleOrder.vehicleType)
  const relevant = discountConfigurations.filter(
    (d) =>
      d.vehicleType === vehicleOrder.vehicleType &&
      (d.metadata.type !== 'volume' || d.metadata.minimumUnitCount <= twelveMonthRollingOrderedUnitCount) &&
      (d.metadata.type !== 'elite' || vehicleOrder.programType === 'adventuresElite') &&
      (d.metadata.type !== 'existingOutfitter' || vehicleOrder.seasonType !== 'FirstSeason') &&
      (d.metadata.type !== 'multiProductLine' || hasMultiLine)
  )

  const maxAmountFromRelevant = relevant.filter((item) => {
    const others = relevant.filter((r) => r.id !== item.id && r.metadata.type === item.metadata.type)
    return !others.some((o) => o.amount > item.amount)
  })

  return maxAmountFromRelevant
}
